module.exports = __webpack_public_path__ + "img/logo-11.de3b7ad1.png";